import { computed } from 'vue';
import { useOidcStore } from 'vue3-oidc';
import { jwtDecode } from 'jwt-decode';
const { state } = useOidcStore();
const userManager = computed(() => state.value.userManager);

class AuthService {
  constructor() {}

  async getRolesFromToken(): Promise<any> {
    try {
      return (await this.getDecodedAccessToken()).role;
    } catch {
      return Promise.resolve();
    }
  }
  getRolesFromTokenNonAsync(): any {
    try {
      return jwtDecode(state.value.user?.access_token ?? '');
    } catch {
      return {};
    }
  }
  private async getDecodedAccessToken(): Promise<any> {
    try {
      return jwtDecode((await userManager.value?.getUser())?.access_token ?? '');
    } catch {
      return {};
    }
  }
}
export default new AuthService();
